<template>
  <div role="search">
    <v-combobox
      @focus="hideInfoDrawer"
      clearable
      :loading="loading"
      v-model="select"
      :search-input.sync="search"
      :items="items"
      aria-label="Søk etter stasjon/stedsnavn.."
      label="Søk etter stasjon/stedsnavn.."
      placeholder="Søk etter stasjon/stedsnavn.."
      append-icon="mdi-magnify"
      return-object
      item-text="text"
      hide-no-data
      no-filter
      @click:clear="clearSearch"
      item-value="text"
      solo
    >
      <template v-slot:item="data">
        <template v-if="typeof data.item !== 'object'">
          <v-list-item-title
            class="text-subtitle-1 primary--text"
            v-text="data.item"
          ></v-list-item-title>
        </template>
        <template v-else>
          <v-list-item-content>
            <v-list-item-title v-html="data.item.text"></v-list-item-title>
          </v-list-item-content>
        </template>
      </template>
    </v-combobox>
  </div>
</template>

<script>
import { loadModules } from "esri-loader";
import { mapState, mapActions } from "vuex";
export default {
  name: "MapSearch",
  props: ["kartview"],
  data: function() {
    return {
      searchViewModel: null,
      graphicsLayer: null,
      infoText: "Klikk i kartet for å starte måling",
      loaded: false,
      fab: false,
      model: null,
      selectedTool: "",
      toggle_exclusive: 0,
      selectedColor: "blue",
      loading: false,
      items: [],
      search: null,
      select: null,
      menuProps: {
        closeOnClick: false,
        closeOnContentClick: false,
      },
      currentlySearchableProfiles: [],
      states: [],
      autoselectMenu: false,
      updatingSources: false,
      selectedSearchItem: null,
    };
  },
  watch: {
    search(val) {
      if (val == "") {
        this.items = [];
      }

      val && val !== this.select && this.querySelections(val);
    },
    select(val) {
      if (val) {
        this.searchViewModel.view = this.kartview;

        if (typeof val === "object") {
          // Hvis det er et suggestion-objekt fra vår custom getSuggestions
          if (val.feature && val.feature.geometry) {
            this.kartview.goTo({
              target: val.feature.geometry,
              zoom: 14,
            });
          } else {
            // Standard SearchViewModel.search for andre kilder
            this.searchViewModel.search(val);
          }
        }
      }
    },
  },
  computed: {
    ...mapState(["mapProfiles", "activeExclusiveToolName", "is3d"]),
    showInfoDrawer: {
      get() {
        return this.$store.state.showInfoDrawer;
      },
      set(newValue) {
        return this.$store.dispatch("setShowInfoDrawer", newValue);
      },
    },
  },
  methods: {
    ...mapActions(["setShowSideMenu"]),
    remove: function(item) {
      const index = this.items.indexOf(item);
      if (index >= 0) {
        this.items.splice(index, 1);
      }
    },
    hideInfoDrawer: function() {
      this.showInfoDrawer = false;
    },
    querySelections(v) {
      this.loading = true;
      this.searchViewModel.suggest(v);
    },
    clearSearch: function() {
      this.autoselectMenu = false;
      this.select = null;
      this.search = null;
      this.items = [];
      this.searchViewModel.clear();
    },
    performSearch: function() {
      this.searchViewModel.search(this.search);
    },
    loadSearch: function() {
      loadModules([
        "esri/widgets/Search/SearchViewModel",
        "esri/layers/FeatureLayer",
      ]).then(([SearchViewModel, FeatureLayer]) => {
        this.searchViewModel = new SearchViewModel({
          view: this.kartview,
          allPlaceholder: "Søk etter sted/stasjon",
          maxSuggestions: 20,
          activeSourceIndex: -1,
          sources: [
            {
              layer: new FeatureLayer({
                url:
                  process.env.VUE_APP_BASE_URL +
                  process.env.VUE_APP_BASE_URL_LAYER_INDEX,
              }),
              searchFields: ["stasjonnr", "stasjonnavn"],
              displayField: "stasjonnr",
              suggestionTemplate: "{stasjonnavn} ({stasjonnr})",
              exactMatch: false,
              outFields: ["stasjonnr", "stasjonnavn"],
              name: "Tidsserier",
              placeholder: "Søk etter sted/stasjon",
              zoomScale: 14000,
              suggestionsEnabled: true,
              minSuggestCharacters: 0,
              maxSuggestions: 50,
              getSuggestions: function(params) {
                let sourceLayer = this.layer; // 'this' refererer til source-objektet
                return loadModules(["esri/rest/support/Query"]).then(
                  ([Query]) => {
                    // Custom søkelogikk: Søk med LIKE for å matche "2.64" mot "2.64.0"
                    let searchTerm = params.suggestTerm.replace(/'/g, "''"); // Escape single quotes
                    // Case-insensitive søk med UPPER
                    let where = `(UPPER(stasjonnr) LIKE '%${searchTerm.toUpperCase()}%' OR UPPER(stasjonnavn) LIKE '%${searchTerm.toUpperCase()}%')`;

                    let query = new Query();
                    query.where = where;
                    query.outFields = ["stasjonnr", "stasjonnavn", "OBJECTID"];
                    query.num = 50;
                    query.returnGeometry = true;

                    return sourceLayer.queryFeatures(query).then((result) => {
                      return result.features.map((feature) => ({
                        key: "name",
                        text: `${feature.attributes.stasjonnavn} (${feature.attributes.stasjonnr})`,
                        sourceIndex: params.sourceIndex,
                        feature: feature,
                      }));
                    });
                  },
                );
              },
            },
            {
              layer: new FeatureLayer({
                url:
                  process.env.VUE_APP_SECOND_LAYER_URL +
                  process.env.VUE_APP_SECOND_URL_LAYER_INDEX,
                definitionExpression: "DATA_EIER_KATEGORI <> 'NVE'",
              }),
              searchFields: ["STASJONID", "STASJONSNAVN"],
              displayField: "STASJONSNAVN",
              suggestionTemplate: "{STASJONID} ({STASJONSNAVN})",
              exactMatch: false,
              outFields: ["STASJONID", "STASJONSNAVN"],
              name: "Tidsserier (andre aktører)",
              placeholder: "Søk etter sted/stasjon",
              zoomScale: 14000,
              suggestionsEnabled: true,
            },
          ],
          goToOverride: function(view, goToParams) {
            let params = {
              target: goToParams.target.target,
            };
            if (
              Object.prototype.hasOwnProperty.call(
                goToParams.target.target,
                "attributes",
              ) &&
              Object.prototype.hasOwnProperty.call(
                goToParams.target.target.attributes,
                "Addr_type",
              )
            ) {
              params.zoom = 15;
            }
            return view.goTo(params, goToParams.options);
          },
          popupEnabled: false,
          suggestionsEnabled: true,
          includeDefaultSources: false,
        });

        //

        this.searchViewModel.on("suggest-complete", (event) => {
          if (event.searchTerm !== this.search) {
            if (this.search == null || this.search === "") {
              this.loading = false;
            }
            return;
          }

          this.loading = false;

          if (event.numResults !== 0) {
            this.autoselectMenu = true;
          }

          this.items = [];

          event.results.forEach((result, index) => {
            if (result.results.length > 0) {
              this.items.push(
                this.searchViewModel.allSources.items[index].name,
              );
            }

            // Sorter resultater slik at eksakte og nærmeste treff kommer først
            let sortedResults = result.results.slice().sort((a, b) => {
              let searchTerm = this.search.toLowerCase().trim();
              let aText = a.text.toLowerCase();
              let bText = b.text.toLowerCase();

              // Hent stasjonsnummer fra parentesen, f.eks. "Glomma (1.62.0)" → "1.62.0"
              let aMatch = aText.match(/\(([^)]+)\)/);
              let bMatch = bText.match(/\(([^)]+)\)/);
              let aNum = aMatch ? aMatch[1] : "";
              let bNum = bMatch ? bMatch[1] : "";

              // Prioritet 1: Eksakt match på stasjonsnummer
              let aExactMatch = aNum === searchTerm;
              let bExactMatch = bNum === searchTerm;
              if (aExactMatch && !bExactMatch) return -1;
              if (!aExactMatch && bExactMatch) return 1;

              // Prioritet 2: Stasjonsnummer starter med søketerm + "." (f.eks. "1.62" matcher "1.62.0")
              let aStartsWith = aNum.startsWith(searchTerm + ".");
              let bStartsWith = bNum.startsWith(searchTerm + ".");
              if (aStartsWith && !bStartsWith) return -1;
              if (!aStartsWith && bStartsWith) return 1;

              // Prioritet 3: Blant de som starter med søketerm, kortere nummer først
              if (aStartsWith && bStartsWith) {
                return aNum.length - bNum.length;
              }

              // Prioritet 4: Stasjonsnummer inneholder søketerm (f.eks. "1.62" matcher "1.623")
              let aContains = aNum.includes(searchTerm);
              let bContains = bNum.includes(searchTerm);
              if (aContains && !bContains) return -1;
              if (!aContains && bContains) return 1;

              return 0;
            });

            for (let i = 0; i < sortedResults.length; i++) {
              let arrayItem = sortedResults[i];

              this.items.push(arrayItem);
            }

            if (this.search == "") {
              this.items = [];
            }
          });
        });

        this.searchViewModel.on(
          "search-complete",
          function() {
            this.loading = false;
          }.bind(this),
        );
      });
    },
  },
  mounted() {
    this.loadSearch();
  },
};
</script>

<style>
.v-select.v-select--is-menu-active .v-input__icon--append .v-icon {
  transform: rotate(0);
}
</style>
